import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { maskConfig, moneyMaskWithoutDecimal } from '@libraries/ui';
import { isDesktop, isMobile } from '@libraries/ui-state';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CloseActive,
  getAddressWithoutZip,
  getImprovementCost,
  getMonthlyCosts,
  isLoading,
  MonthlyCostInformation,
  ReCalculateMonthlyCost,
  RedirectToApplication,
} from '../../state';

@Component({
  templateUrl: './calculate-other-improvement-monthly-cost.component.html',
  styleUrls: ['./calculate-other-improvement-monthly-cost.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CalculateOtherImprovementMonthlyCostComponent implements OnInit {
  costForm: UntypedFormGroup;
  moneyMaskWithoutDecimal = moneyMaskWithoutDecimal;
  maskConfig = maskConfig;
  monthlyCosts$: Observable<MonthlyCostInformation[]> = this.store.pipe(select(getMonthlyCosts));
  estimatedCost$ = this.store.pipe(select(getImprovementCost));
  address$ = this.store.pipe(select(getAddressWithoutZip));
  isDesktop$ = this.store.pipe(select(isDesktop));
  isMobile$ = this.store.pipe(select(isMobile));
  isLoading$ = this.store.pipe(select(isLoading));

  imageName$: Observable<string>;

  constructor(private fb: UntypedFormBuilder, private store: Store) {
    this.imageName$ = combineLatest([this.isMobile$, this.monthlyCosts$]).pipe(
      map(([mobile, hasMonthlyCosts]) =>
        mobile && hasMonthlyCosts?.length ? '' : 'estimatedCostsSuccess'
      )
    );
  }

  ngOnInit(): void {
    this.costForm = this.fb.group({
      estimated_cost: [
        null,
        {
          updateOn: 'focus',
          validators: [Validators.required, Validators.min(5000), Validators.max(100000000)],
        },
      ],
    });
  }

  navigate() {
    this.store.dispatch(RedirectToApplication());
  }

  close() {
    this.store.dispatch(CloseActive());
  }

  submit() {
    this.costForm.markAllAsTouched();
    if (this.costForm.invalid) return;
    this.store.dispatch(ReCalculateMonthlyCost({ payload: this.costForm.value }));
  }
}
